<template>
    <div class="app-view-template-industry-cases">
      <app-view-template-secondary :title="title" :brands="brands">

        <slot />

      </app-view-template-secondary>

    </div>
</template>

<script>
  import AppViewTemplateSecondary from '@/components/layout/templates/view/AppViewTemplateSecondary';

  export default {
      name: 'AppViewTemplateIndustryCases',

      props: {
        title: String,
        brands: {
            type: Object,
        },
      },

      components: {
          AppViewTemplateSecondary,
      },
  }
</script>

<style scoped lang="scss">
  .app-view-template-industry-cases {

  }
</style>
